<template>
  <div :class="'md-layout'">
    <div :class="'md-layout-item md-size-100'">
      <md-card>
        <md-card-header :class="'md-card-header-icon md-card-header-danger'">
          <div :class="'card-icon'">
            <md-icon>assignment</md-icon>
          </div>
          <h4 :class="'title'">
            Review report
            <md-card-header :class="'text-right screen-only'">
              <md-button :class="'md-simple pull-right'" :md-ripple="false" @click.prevent="exportXlsx"
                title="Print this report">
                <span>Download this report</span>
                <md-icon>download</md-icon>
              </md-button>
            </md-card-header>
          </h4>
        </md-card-header>
        <md-card-content>
          <div :class="'md-layout'">
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label :class="'title-select'">Reviewer</label>
                <select :class="'custom-select'" placeholder="Reviewer" v-model="filter.rqr_reviewer" md-dense>
                  <option value="">Reviewer</option>
                  <option :value="user.id" v-for="(user, i) in users" :key="i">
                    {{ user.name }}
                  </option>
                </select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label :class="'title-select'">Engagement Leader</label>
                <select :class="'custom-select'" placeholder="Engagement Leader" v-model="filter.engagement_leader"
                  md-dense>
                  <option value="">Engagement Leader</option>
                  <option :value="user.id" v-for="(user, i) in users" :key="i">
                    {{ user.name }}
                  </option>
                </select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label>Review Reference</label>
                <md-select v-model="filter.reference" md-dense>
                  <md-option v-for="(rf, idx) in references" :key="idx" :value="rf.id">
                    {{ rf.reference }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label>Fiscal Year</label>
                <md-select placeholder="Fiscal Year" v-model="filter.fiscal_year" md-dense>
                  <md-option :key="idx" :value="year" v-for="(year, idx) in fiscalYears">
                    {{ year }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label>RQR Type</label>
                <md-select placeholder="RQR Type" v-model="filter.rqr_type" md-dense>
                  <md-option :value="code" :key="code" v-for="(type, code) in rqrTypesMap">
                    {{ type }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label for="section">Standard</label>
                <md-select name="section" id="section" placeholder="Standard" v-model="filter.section">
                  <md-option :value="code" :key="code" v-for="(type, code) in sectionStandardMap">
                    {{ type }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { reviewStatus, rqrType, ratingClass } from "@/filters";
import { rqrTypesMap } from "@/filters/rqrType";
import { sectionStandardMap } from "@/filters/sectionStandard";

import { Pagination } from "@/components";
import { camelToSnake } from "@/methods/api/requests";
import * as utils from "@/utils";
import * as filters from "@/filters";

export default {
  created() {
    if (!this.canViewReport) {
      this.$router.push({ name: "Reviews" });
      this.$toast.show(
        "Only admins, reviewers and RQR leaders can access reports"
      );
      return;
    }

    this.filter["engagement_leader"] = this.$store.state["reviewslistingFilters"]["engagement_leader"];
    this.filter["rqr_reviewer"] = this.$store.state["reviewslistingFilters"]["rqr_reviewer"];
    this.filter["fiscal_year"] = this.$store.state["reviewslistingFilters"]["fiscal_year"];
    this.filter["rqr_type"] = this.$store.state["reviewslistingFilters"]["rqr_type"];

    this.getUsers();
    this.getReferences();
  },

  data() {
    return {
      references: [],
      questionnaries: [],
      users: [],
      isFetching: false,
      isTryingToDelete: false,
      deletableReview: {},
      isDeletingReview: false,
      filter: {
        engagement_leader: "",
        rqr_reviewer: "",
        fiscal_year: "",
        rqr_type: "",
        reference: "",
        section: "",
        /* Fixed status for only finished reviews
          status: 5,
          */
      },
      pagination: {
        totalItems: "",
        currentPage: "",
        perPage: "",
      },
      rqrTypesMap,
      sectionStandardMap,
    };
  },

  components: {
    Pagination,
  },

  computed: {
    filtersQuery() {
      return filters.getFiltersQuery(this.filter);
    },

    paginationQuery() {
      return utils.getPaginationQuery(this.pagination.currentPage);
    },

    fiscalYears() {
      return utils.getFiscalYears();
    },

    currentProfile() {
      return this.$store.state.currentProfile;
    },

    draftResultsOnly() {
      return this.currentProfile === "reviewer" || this.currentProfile === "rqr_leader" ? true : false;
    },

    isAdmin() {
      return this.$store.getters.isAdmin;
    },

    isReviewer() {
      return this.$store.state.currentProfile === "reviewer" ? true : false;
    },

    isRQRLeader() {
      return this.$store.state.currentProfile === "rqr_leader" ? true : false;
    },

    isAdminTI() {
      return this.$store.state.currentProfile === "adminTi" ? true : false;
    },

    isAudit() {
      return this.$store.state.currentProfile === "audit" ? true : false;
    },

    canViewReport() {
      return this.isAdmin || this.isReviewer || this.isRQRLeader ||
        this.isAdminTI || this.isAudit ? true : false;
    },
  },

  filters: {
    reviewStatus,
    ratingClass,
    rqrType,
  },

  methods: {
    async exportXlsx() {
      this.$api.request
        .get(`report/export-excel?${this.filtersQuery}`, {
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Content-Type",
          },
          responseType: "arraybuffer",
        })
        .then((response) => {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.ms-excel",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "report.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(async (err) => {
          const errJson = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = (e) => {
              resolve(JSON.parse(e.target.result));
            };
            reader.readAsText(err.response.data);
          });
          return errJson;
        });
    },

    getReferences() {
      this.$api.request("all/advisories").then((response) => {
        this.references = camelToSnake(response.data)
          // .sort((a, b) => a.reference.localeCompare(b.reference));
      });
    },

    getUsers() {
      this.isFetching = true;
      this.$api
        .request("all/users")
        .then((response) => {
          this.users = camelToSnake(response.data)
          .filter((d) => d.inactive_user === null)
            // .sort((a, b) => a.name.localeCompare(b.name));
        })
        .finally(() => {
          this.isFetching = false;
        });
    },

    printReport() {
      window.print();
    },
  },

  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
